import React, { useState } from 'react';
import { LuChevronDown, LuMapPin, LuExternalLink } from 'react-icons/lu';

import Reveal from './Reveal';
import { EXPERIENCE } from './Content_data';

const Experience = () => {
    const [activeIndex, setActiveIndex] = useState(0);

    return (
        <div className='experience-list'>
            {EXPERIENCE.map((item, index) => {
                const isOpen = activeIndex === index;

                return (
                    <Reveal
                        key={item.company}
                        delay={index * 60}
                        className={`experience-item ${isOpen ? 'is-open' : ''}`}
                    >
                        <button
                            className='experience-head'
                            onClick={() => setActiveIndex(isOpen ? -1 : index)}
                            aria-expanded={isOpen}
                        >
                            <span className='logo'>
                                <img src={item.logo} alt={item.company} />
                            </span>

                            <span className='heading'>
                                <span className='role'>{item.role}</span>
                                <span className='company'>{item.company}</span>
                            </span>

                            <span className='period'>{item.period}</span>

                            <span className='chevron'>
                                <LuChevronDown />
                            </span>
                        </button>

                        <div className='experience-body'>
                            <div className='experience-body-inner'>
                                <div className='meta'>
                                    <span><LuMapPin /> {item.location}</span>
                                    {item.website && (
                                        <a href={item.website} target='_blank' rel='noreferrer'>
                                            <LuExternalLink /> {item.websiteLabel}
                                        </a>
                                    )}
                                </div>

                                <p>{item.description}</p>

                                <div className='tags'>
                                    {item.tags.map(tag => (
                                        <span key={tag}>{tag}</span>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </Reveal>
                );
            })}
        </div>
    );
};

export default Experience;
